module.exports = __webpack_public_path__ + "7925089d1f71368ab82fe4007b705c59.png";